import { Component } from '@angular/core';

@Component({
  selector: 'app-tac24',
  templateUrl: './tac24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Tac24Component {

}
